import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SessionService } from '../services/api/session/session.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  apiUrl = '';
  constructor(private router: Router, private sessionService: SessionService) {}

  getApiUrl() {
    if (this.apiUrl) {
      return this.apiUrl;
    }

    this.apiUrl = environment.apiUrl;
    return this.apiUrl;
  }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    if (token) {
      return req.clone({ setHeaders: { Authorization: token } });
    } else {
      return req.clone({});
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('assets/') > -1) {
      return next.handle(req);
    }

    if (req.url.includes('sessions/verify')) {
      return next.handle(req);
    }
    if (req.url.includes('users/update_pin')) {
      return next.handle(req);
    }

    const url = this.getApiUrl();
    const reqUrl = url + req.url;
    const session = this.sessionService.getSession();

    if (!req.url.includes('http')) {
      req = req.clone({ url: req + req.url });

      if (session != null) {
        if (session) {
          req = req.clone({
            setHeaders: {
              Authorization: session.access_token,
            },
          });
        }
      }
    }

    req = req.clone({
      url: reqUrl,
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
      },
    });
    return next.handle(this.addToken(req, null)).pipe(
      map((event: any) => {
        return event;
      }),
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.router.navigateByUrl('/auth');
          }
          return throwError(err);
        }
      })
    );
  }
}
